import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import { setLocale } from "@/lib/journal";

export const LANGUAGES = [
  { id: "en", label: "English" },
  { id: "ru", label: "Русский" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, ru: { translation: ru } },
    fallbackLng: "en",
    supportedLngs: ["en", "ru"],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "tj13_lang",
      caches: ["localStorage"],
    },
  });

// Numbers, dates and currency follow the chosen language (ru → 1 234,56 / 29.10.2026).
setLocale(i18n.language);
document.documentElement.lang = i18n.language?.startsWith("ru") ? "ru" : "en";
i18n.on("languageChanged", (lng) => {
  setLocale(lng);
  document.documentElement.lang = lng;
});

export default i18n;
